import { useState } from "react";
import { useAtomValue } from "jotai";

import {
  ActionsCloseButton,
  FloatingToolbar,
  IconAction,
} from "../../components/PageView/PageViewTable/SharedToolbar/SharedSelectedRecordsActions";
import { IsMobileAtom } from "../../App";
import UnshareModal from "./UnshareModal";

const SharedCenterSelectedRecordsActions = ({
  onClear,
  moduleAPIName,
  selectedRecordIds,
}: {
  onClear: () => void;
  moduleAPIName: string;
  selectedRecordIds: string[];
}) => {
  const [openUnshare, setUnshare] = useState(false);
  const isMobile = useAtomValue(IsMobileAtom);
  const length = selectedRecordIds?.length;

  return (
    <>
      <FloatingToolbar>
        <ActionsCloseButton onClear={onClear} length={length} />
        <div
          className="d-flex align-items-center ml-2"
          style={{ overflowX: "auto" }}
        >
          <IconAction
            icon="share-off"
            title="Unshare"
            isMobile={isMobile}
            onClick={() => setUnshare(true)}
          />
        </div>
      </FloatingToolbar>
      <UnshareModal
        open={openUnshare}
        handleClose={() => {
          setUnshare(false);
          onClear();
        }}
        moduleAPIName={moduleAPIName}
        recordIds={selectedRecordIds}
      />
    </>
  );
};

export default SharedCenterSelectedRecordsActions;
